import { SocialProfile } from '@/models/socialprofile/socialprofile';
import { SocialProfileGroup } from '@/models/socialprofile/socialprofilegroup';
import { Component, Vue } from 'vue-property-decorator';

export const DOMAIN_MAPPERS = {
  Facebook: ['facebook', 'fb'],
  Github: ['github'],
  Linkedin: ['linkedin', 'lnkd'],
  StackOverflow: ['stackoverflow'],
  Twitter: ['twitter', 'x', 't'],
  Instagram: ['Instagram', 'instagr'],
  TikTok: ['tiktok'],
  Website: ['website'],
};
@Component
export default class SocialProfileValidator extends Vue {
  public isInValidSocialProfilelink(name: string, profileLink: string): string {
    var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (!pattern.test(profileLink)) {
      return 'socialprofile.profilelink.invalidurl';
    }
    let isValidDomain = false;
    let domain = new URL(profileLink).hostname.split('.');
    let profileLinkDomain =
      domain.length > 2 ? domain.slice(1, -1).join('.') : domain[0];
    // if any new social network need to add in domain mappers
    if (DOMAIN_MAPPERS[name]) {
      DOMAIN_MAPPERS[name].forEach((item, idx) => {
        if (profileLinkDomain.toLowerCase() == item) isValidDomain = true;
      });
    }
    const isInvalid = name != 'Website' && !isValidDomain;
    // !profileLink.toLowerCase().includes(name);
    if (isInvalid) return 'socialprofile.profilelink.invalid';
    return '';
  }

  public validateFormNew(
    currentSocialProfile: SocialProfile,
    socialProfileGroupList: SocialProfileGroup[],
  ): boolean {
    var isValid = true;
    socialProfileGroupList.forEach((item, index) => {
      if (item.name == currentSocialProfile.name) {
        item.details.forEach((profile, profileIndex) => {
          if (
            currentSocialProfile.id != profile.id &&
            profile.profileLink === currentSocialProfile.profileLink
          ) {
            isValid = false;
          }
        });
      }
    });
    return isValid;
  }
}
